// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"eab49c3c","60":"775220fd","70":"2b05b5ef","141":"ff7db608","144":"eda4fd90","158":"07ad051b","467":"6840dfc7","499":"aab48c4f","603":"8d11040a","620":"f7b99d0c","662":"75d9f252","722":"026a0b41","735":"02ec7f5c","850":"893e3e96","897":"bcbd7a86"}[chunkId] + ".chunk.js";
};